/*
 * rheincool — PLZ-Montagecheck (Produktdetail-Handoff §6)
 *
 * Prüft die PLZ gegen die Präfixe der montagegebiet-Metaobjekte.
 * verfügbar → grün mit frühestem Termin (heute + vorlauf Werktage)
 * außerhalb → neutral + Partnerbetrieb-Link (nie Sackgasse)
 * ungültig  → deutsche Fehlermeldung
 * PLZ wird in localStorage (rc-plz) gemerkt und beim Laden erneut geprüft.
 */
class RcPlzCheck extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-plz-input]');
    this.submit = this.querySelector('[data-plz-submit]');
    this.result = this.querySelector('[data-plz-result]');
    this.partnerLink = this.querySelector('[data-plz-partner]');
    try {
      this.areas = JSON.parse(this.querySelector('[data-plz-areas]').textContent);
      this.strings = JSON.parse(this.querySelector('[data-plz-strings]').textContent);
    } catch {
      return;
    }

    this.submit.addEventListener('click', () => this.check());
    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.check();
      }
    });

    const saved = localStorage.getItem('rc-plz');
    if (saved) {
      this.input.value = saved;
      this.check(true);
    }
  }

  /* heute + n Werktage (Mo–Fr) */
  addWorkdays(days) {
    const d = new Date();
    let left = days;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() >= 1 && d.getDay() <= 5) left -= 1;
    }
    return d.toLocaleDateString('de-DE', { day: 'numeric', month: 'long' });
  }

  check(silent) {
    const plz = (this.input.value || '').trim();
    if (!/^\d{5}$/.test(plz)) {
      if (silent) return;
      this.show('invalid', this.strings.invalid);
      return;
    }
    localStorage.setItem('rc-plz', plz);

    const area = this.areas.find((a) =>
      String(a.praefixe || '')
        .split(',')
        .map((p) => p.trim())
        .filter(Boolean)
        .some((prefix) => plz.startsWith(prefix))
    );

    if (area) {
      const date = this.addWorkdays(parseInt(area.vorlauf, 10) || 10);
      this.show(
        'available',
        this.strings.available.replace('[region]', area.region || '').replace('[plz]', plz).replace('[datum]', date)
      );
    } else {
      this.show('partner', this.strings.partner.replace('[plz]', plz));
    }
    if (window.rcTrack && !silent) {
      window.rcTrack('zip_check', { plz, ergebnis: area ? 'verfuegbar' : 'partner' });
    }
  }

  show(state, text) {
    this.result.hidden = false;
    this.result.textContent = text;
    this.result.dataset.state = state;
    this.partnerLink.hidden = state !== 'partner';
  }
}

customElements.define('rc-plz-check', RcPlzCheck);
